<template>
  <v-container class="landing" @click="landingOnClick">
    <v-row class="text-center white--text font-weight-bold heading-title">
      <v-col sm="12">
        {{ siteText.ui.kioskLandingTitle }}
      </v-col>
    </v-row>
    <v-row class="logo-row">
      <v-col sm="12">
        <v-img class="text-center mx-auto mt-10 logo" :src="logo"></v-img>
      </v-col>
    </v-row>
    <v-row class="instructions-row">
      <v-col sm="12" class="instructions">
        <p class="text-center">
          {{ siteText.ui.kioskLandingStartTest }}
        </p>
        <p v-if="Error" class="error-message">
          {{ ErrorText }}
        </p>
      </v-col>
    </v-row>
    <v-row class="station white--text">
      <v-col sm="12" v-if="KioskNumber > 0">
        <p class="text-center">Station {{ KioskNumber }}</p>
      </v-col>
    </v-row>
    <div class="version-info">
      <div class="version-info-left">
        {{ kioskSerialNumber }}
      </div>
      <div class="version-info-right">
        {{ siteVersion }}
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      ErrorText: "",
      Error: false,
      KioskNumber: 0,
      logo: require("../assets/images/TXdpsLogo.png"),
    };
  },
  async created() {
    try {
      const kioskData = await this.intializeKiosk(this.kioskSerialNumber);
      console.log(kioskData);
      this.KioskNumber = kioskData.kioskNumber;
      await this.getSettings();
    } catch (error) {
      this.setSystemError({
        message: this.siteText.errors.kioskFailedToInitialize,
        allowRefresh: true,
      });
      this.clearBusy();
    }
  },
  methods: {
    ...mapActions([
      "intializeKiosk",
      "getKioskExamineeInfo",
      "kioskStartLogin",
      "setBusy",
      "clearBusy",
      "setUserDetails",
      "getSettings",
      "setSystemError",
    ]),
    async landingOnClick() {
      if (this.Error) {
        document.location.reload();
      } else {
        this.getAssignedExaminee();
      }
    },
    async getAssignedExaminee() {
      let examineeInfo = null;
      try {
        examineeInfo = await this.getKioskExamineeInfo(this.kioskSerialNumber);
        this.validateExamineeInfo(examineeInfo);
        console.log(examineeInfo);
        this.kioskStartLogin(examineeInfo);
      } catch (error) {
        this.setError(error);
      }
    },
    setError(errorMessage) {
      this.Error = true;
      this.ErrorText = errorMessage;
      setTimeout(function() {
        document.location.reload();
      }, 5000);
    },
    validateExamineeInfo(examineeInfo) {
      if (!examineeInfo) {
        throw this.siteText.ui.noAssignedTestsFound;
      } else if (examineeInfo.hasSuspendedTests) {
        throw this.siteText.ui.testSuspended;
      } else if (examineeInfo.lockedOut) {
        throw this.siteText.ui.accountLockedOut;
      }
    },
  },
  computed: {
    ...mapGetters(["siteText", "kioskSerialNumber", "siteVersion"]),
  },
};
</script>

<style></style>

<style scoped>
.landing {
  background: url("../assets/images/kiosk_ktLanding_plain.png");
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 100%;
  height: 100vh;
  max-width: 100%;
}

.logo {
  width: 400px;
  height: 400px;
}

.logo-row {
  height: 50%;
}

.instructions-row {
  height: 15%;
}

.heading-title {
  font-size: 28pt !important;
  height: 5%;
}

.error-message {
  color: red;
  text-align: center;
  padding-top: 20px;
  font-size: 24pt !important;
}

@media screen and (max-width: 700px) {
  .logo {
    width: 300px;
    height: 300px;
  }

  .heading-title {
    font-size: 14pt !important;
  }

  .instructions {
    font-size: 20pt !important;
  }

  .station {
    font-size: 80pt !important;
  }
}

@media screen and (max-width: 500px) {
  .logo {
    width: 200px;
    height: 200px;
  }

  .heading-title {
    font-size: 12pt !important;
  }

  .instructions {
    font-size: 18pt !important;
  }

  .station {
    font-size: 60pt !important;
  }

  .error-message {
    padding-top: 10px;
    font-size: 16pt !important;
  }
}

@media screen and (max-width: 900px) and (max-height: 600px) {
  .container {
    padding-top: 5px !important;
  }
  .logo {
    width: 150px;
    height: 150px;
  }

  .heading-title {
    font-size: 12pt !important;
  }

  .instructions {
    font-size: 18pt !important;
  }

  .station {
    font-size: 60pt !important;
  }
}

.instructions {
  font-size: 40pt;
  font-weight: bold;
  /*padding-top: 150px;*/
  /*position: relative;  
    bottom: 425px;
    top: 500px;*/
  width: 100%;
  margin: auto;
  justify-content: center;
  vertical-align: bottom;
}

.station {
  font-size: 150pt;
  position: absolute;
  padding-top: 10px;
  bottom: 0px;
  font-weight: bold;
  width: 100%;
  margin: auto;
  height: 25%;
}

.version-info div {
  width: 100%;
  position: absolute;
  bottom: 5px;
  font-size: 12px;
  color: white;
}

.version-info-right {
  text-align: right;
  padding-right: 25px;
}

.version-info-center {
  text-align: center;
}

.version-info-left {
  text-align: left;
  padding-left: 5px;
}

p {
  margin-bottom: 0px !important;
  line-height: 1;
}
</style>
